import React, {useEffect, useState, useMemo} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import JString from '@easytech-international-sdn-bhd/jstring';
import MUIDataTable from 'mui-datatables';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';
import {ck_st_dtl_columns, no_image, req_stock_take, req_stock_take_editqty} from '../../Helper/Constants';
import Image from 'material-ui-image';
import { useCookies } from 'react-cookie';
import _ from 'lodash';
import API_Service, { axiosURIencode } from '../../Services/API_Service';
import { de } from '../../Helper/Helper';
import {useSnackbar} from 'notistack';

const useStyles = makeStyles((theme) => ({
	image: {
		maxWidth: 150,
		marginLeft: 10
	},
	large_image: {
		maxWidth: 450,
		maxHeight: 450
	},
	appBar: {
		position: 'relative',
	},
	title: {
		marginLeft: theme.spacing(2),
		flex: 1,
	},
	root: {
		width: '100%',
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: theme.typography.fontWeightMedium,
	},
	viewInRow: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	attachment_title: {
		marginTop: 20,
		marginLeft: 10
	},
	image_title: {
		textAlign: 'center',
		fontSize: 16,
		color: "black"
	},
	image_desc: {
		textAlign: 'center',
		fontSize: 14,
		color: "grey"
	},
	qtyInput: {
		width: 80,
		'& input': {
			textAlign: 'right',
			color: 'inherit'
		},
		'& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
			filter: 'invert(1)'
		}
	},
	actionCell: {
		display: 'flex',
		alignItems: 'center',
		gap: 4
	},
	actionIcon: {
		padding: 4,
		'& .MuiIconButton-label': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center'
		},
		'& .MuiSvgIcon-root': {
			display: 'block'
		}
	}
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const headCells = [
	{
		name: "id",
		label: "ID",
		options: {
			display: false
		}
	},
	{
		name: "product_code",
		label: "Code",
		options: {
			display: true
		}
	},
	{
		name: "product_name",
		label: "Name",
		options: {
			display: true
		}
	},
	// {
	// 	name: "image_url",
	// 	label: "Image",
	// 	options: {
	// 		display: true,
	// 		customBodyRender: (value, tableMeta, updateValue) => {
	// 			if (value) {
	// 				return (
	// 					<div style={{width: 100, height: 100}}>
	// 						<Image alt={value} src={value || no_image}/>
	// 					</div>
	// 				)
	// 			}
	// 		}
	// 	}
	// },
	{
		name: "sp_remark",
		label: "Remark",
		options: {
			display: true
		}
	},
	{
		name: "current_quantity",
		label: "Current Quantity",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				switch (value) {
					case '1888888':
						return 'High';
					case '1555555':
						return 'Medium';
					case '1111111':
						return 'Low';
					case '-111111':
						return '';
				}
				value = parseInt(value);
				if (value < 3 && value !== 0) {
					return (<Chip size="small" label={value} style={{ backgroundColor: "orange" }} />);
				} else if (value === 0) {
					return (<Chip size="small" label={value} style={{ backgroundColor: "red" }} />);
				} else {
					return value;
				}
			}
		}
	},
	{
		name: "delist",
		label: "Listing",
		options: {
			display: false,
			customBodyRender: (value, tableMeta, updateValue) => {
				if (value === '-111111') {
					return 'Delist';
				}
				if (value === 'new') {
					return 'New';
				}
				return '';
			}
		}
	},
	{
		name: "suggested_quantity",
		label: "Proposed QTY",
		options: {
			display: true
		}
	},
	{
		name: "unit_uom",
		label: "UOM",
		options: {
			display: true
		}
	},
	// {
	// 	name: "shelf_location",
	// 	label: "Shelf",
	// 	options: {
	// 		display: true
	// 	}
	// },
	// {
	// 	name: "suggest_return",
	// 	label: "Return",
	// 	options: {
	// 		display: true,
	// 		customBodyRender: (value, tableMeta, updateValue) => {
	// 			switch (value) {
	// 				case "1" :
	// 					return (<Chip size="small" icon={<DoneIcon/>} label="YES"/>);
	// 					break;
	// 				case "0" :
	// 					return (<Chip size="small" icon={<CloseIcon/>} label="NO"/>);
	// 					break;
	// 				default :
	// 					return (<Chip size="small" icon={<CloseIcon/>} label="NO"/>);
	// 					break;
	// 			}
	// 		}
	// 	}
	// },
	// {
	// 	name: "suggest_transfer",
	// 	label: "Transfer",
	// 	options: {
	// 		display: true,
	// 		customBodyRender: (value, tableMeta, updateValue) => {
	// 			switch (value) {
	// 				case "1" :
	// 					return (<Chip size="small" icon={<DoneIcon/>} label="YES"/>);
	// 					break;
	// 				case "0" :
	// 					return (<Chip size="small" icon={<CloseIcon/>} label="NO"/>);
	// 					break;
	// 				default :
	// 					return (<Chip size="small" icon={<CloseIcon/>} label="NO"/>);
	// 					break;
	// 			}
	// 		}
	// 	}
	// },
	{
		name: "expiry_date",
		label: "Expiry Date",
		options: {
			display: true,
			customBodyRender: (value, tableMeta) => {
				let diffy = new Date(value).getFullYear() - new Date().getFullYear();
				let timenow = new Date().getTime() + (30 * 24 * 60 * 60 * 1000);
				let timevalue = new Date(value).getTime();

				if (diffy === 0 && timenow > timevalue) {
					return (<Chip size="small"
						label={moment(value, 'YYYY-MM-DD').format('YYYY') === '1970' ? '' : moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')}
						style={{ backgroundColor: "red" }} />);
				} else {
					return moment(value, 'YYYY-MM-DD').format('YYYY') === '1970' ? '' : moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY');
				}
			}
		}
	},
	// {
	// 	name: "foc_qty",
	// 	label: "FOC",
	// 	options: {
	// 		display: true
	// 	}
	// },
	{
		name: "markdown_price",
		label: "Retail Selling Price",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				return JString(value).inCurrency()
			}
		}
	},
	{
		name: "active_status",
		label: "Status",
		options: {
			display: true,
			customBodyRender: (value, tableMeta, updateValue) => {
				switch (value) {
					case "1":
						return (<Chip size="small" icon={<DoneIcon />} label="Active" />);
						break;
					case "0":
						return (<Chip size="small" icon={<CloseIcon />} label="Cancelled" />);
						break;
					default:
						return (<Chip size="small" icon={<DoneIcon />} label="Active" />);
						break;
				}
			}
		}
	}
];

export default function StockTakeDetails({open, setClose, language, axiosConfig, stockTakeID, username}) {
	const classes = useStyles();
	const [items, setItems] = useState([]);
	const [cookies, setCookie] = useCookies([ck_st_dtl_columns]);
	const [editingRowId, setEditingRowId] = useState(null);
	const [editValues, setEditValues] = useState({});
	const [isSaving, setIsSaving] = useState(false);
	const {enqueueSnackbar} = useSnackbar();

	useEffect(() => {
		// createRows(itemList?.items);
		if (open) {
			const param = axiosURIencode({
				doc_id: stockTakeID
			});
			API_Service.get(`${req_stock_take}?${param}`, axiosConfig).then(({ data }) => {
				const { result, extraData } = data;
				if (parseInt(result) === 1) {
					setItems(items => (extraData));
				}
			});
		}
	}, [open]);

	// const createRows = (__itemList) => {
	// 	if (__itemList) {
	// 		var _data = [];
	// 		for (let i = 0; i < __itemList.length; i++) {
	// 			_data.push(
	// 				__itemList[i]
	// 			);
	// 		}
	// 		setItems(items => (_data));
	// 	}
	// }

	const handleEdit = (rowIndex) => {
		const row = items[rowIndex];
		setEditingRowId(row.id);
		setEditValues({
			current_quantity: row.current_quantity || '',
			suggested_quantity: row.suggested_quantity || ''
		});
	};

	const handleCancel = () => {
		setEditingRowId(null);
		setEditValues({});
	};

	const handleSave = () => {
		const rowIndex = items.findIndex(item => item.id === editingRowId);
		if (rowIndex === -1) return;

		setIsSaving(true);
		const formdata = new FormData();
		formdata.append('id', editingRowId);
		formdata.append('current_quantity', editValues.current_quantity);
		formdata.append('suggested_quantity', editValues.suggested_quantity);
		formdata.append('username', username || '');

		API_Service.post(req_stock_take_editqty, formdata, axiosConfig)
			.then(({data}) => {
				if (data.result == 1) {
					const updated = [...items];
					updated[rowIndex] = {...updated[rowIndex], ...editValues};
					setItems(updated);
					setEditingRowId(null);
					setEditValues({});
					enqueueSnackbar(language.record_updated, {variant: 'success'});
				} else {
					enqueueSnackbar(data.message || language.edit_qty_failed, {variant: 'error'});
				}
				setIsSaving(false);
			})
			.catch(() => {
				enqueueSnackbar(language.edit_qty_failed, {variant: 'error'});
				setIsSaving(false);
			});
	};

	const resetAndClose = () => {
		setItems([]);
		setEditingRowId(null);
		setEditValues({});
		setClose();
	}

	const redefineHeaders = (columns) => {
		const lastSelection = cookies[ck_st_dtl_columns];
		if (_.isEmpty(lastSelection)) {
			return columns;
		}
		columns = columns.map((item) => {
			const key = item.name;
			var objCopy = _.merge({}, item);
			if (_.has(lastSelection, key)) {
				objCopy.options.display = lastSelection[`${key}`];
			}
			return objCopy;
		});
		return columns;
	}

	const editableColumns = useMemo(() => {
		const cols = headCells.map((col) => {
			if (col.name === 'current_quantity') {
				return {
					...col,
					options: {
						...col.options,
						customBodyRender: (value, tableMeta) => {
							const rowData = items[tableMeta.rowIndex];
							if (rowData && rowData.id === editingRowId) {
								return (
									<TextField
										type="number"
										size="small"
										className={classes.qtyInput}
										value={editValues.current_quantity}
										onChange={(e) => setEditValues(prev => ({...prev, current_quantity: e.target.value}))}
									/>
								);
							}
							switch (value) {
								case '1888888': return 'High';
								case '1555555': return 'Medium';
								case '1111111': return 'Low';
								case '-111111': return 'Delist';
							}
							const intVal = parseInt(value);
							if (intVal < 3 && intVal !== 0) {
								return (<Chip size="small" label={intVal} style={{backgroundColor: "orange"}}/>);
							} else if (intVal === 0) {
								return (<Chip size="small" label={intVal} style={{backgroundColor: "red"}}/>);
							}
							return intVal;
						}
					}
				};
			}
			if (col.name === 'suggested_quantity') {
				return {
					...col,
					options: {
						...col.options,
						customBodyRender: (value, tableMeta) => {
							const rowData = items[tableMeta.rowIndex];
							if (rowData && rowData.id === editingRowId) {
								return (
									<TextField
										type="number"
										size="small"
										className={classes.qtyInput}
										value={editValues.suggested_quantity}
										onChange={(e) => setEditValues(prev => ({...prev, suggested_quantity: e.target.value}))}
									/>
								);
							}
							return value;
						}
					}
				};
			}
			return col;
		});
		cols.push({
			name: "actions",
			label: " ",
			options: {
				display: true,
				filter: false,
				sort: false,
				viewColumns: false,
				customBodyRender: (value, tableMeta) => {
					const rowData = items[tableMeta.rowIndex];
					if (!rowData) return null;
					const isEditing = rowData.id === editingRowId;
					if (isEditing) {
						return (
							<div className={classes.actionCell}>
								<Tooltip title={language.save || 'Save'}>
									<IconButton size="small" className={classes.actionIcon} onClick={(e) => { e.stopPropagation(); handleSave(); }} disabled={isSaving}>
										<CheckIcon fontSize="small" style={{color: 'green'}} />
									</IconButton>
								</Tooltip>
								<Tooltip title={language.cancel || 'Cancel'}>
									<IconButton size="small" className={classes.actionIcon} onClick={(e) => { e.stopPropagation(); handleCancel(); }} disabled={isSaving}>
										<CloseIcon fontSize="small" style={{color: 'red'}} />
									</IconButton>
								</Tooltip>
							</div>
						);
					}
					return (
						<Tooltip title={language.edit_quantity || 'Edit Quantity'}>
							<IconButton size="small" onClick={(e) => { e.stopPropagation(); handleEdit(tableMeta.rowIndex); }} disabled={editingRowId !== null}>
								<EditIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					);
				}
			}
		});
		return cols;
	}, [items, editingRowId, editValues, isSaving]);

	const tableHead = redefineHeaders(editableColumns);

	const docTableColumnsChanged = (changedColumns, action) => {
		const lastSelection = cookies[ck_st_dtl_columns];
		var obj = {};
		var a = headCells.map((item) => {
			if (item.name == changedColumns) {
				obj[`${item.name}`] = action == 'add';
				return { [`${item.name}`]: action == 'add' };
			}
			obj[`${item.name}`] = (lastSelection && _.has(lastSelection, `${item.name}`)) ? lastSelection[`${item.name}`] : item.options.display;
			return { [`${item.name}`]: item.options.display };
		});
		setCookie(ck_st_dtl_columns, JSON.stringify(obj), { path: '/', sameSite: true, maxAge: 36000 * 3600 });
	}

	return (
		<div>
			<Dialog fullScreen open={open} onClose={() => resetAndClose()} TransitionComponent={Transition}>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton edge="start" color="inherit" onClick={() => resetAndClose()} aria-label="close">
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" className={classes.title}>
							{language.stock_take_details}
						</Typography>
					</Toolbar>
				</AppBar>
				<div>
					<MUIDataTable
						title={items.length > 0 ? `# ${stockTakeID}` : ''}
						data={items}
						columns={tableHead}
						options={{
							filter: false,
							print: false,
							selectableRows: 'none',
							rowsPerPage: 50,
							rowsPerPageOptions: [50, 100, 150],
							responsive: 'scrollMaxHeight',
							setTableProps: () => ({ size: 'small' }),
							onColumnViewChange: (changedColumns, direction) => {
								docTableColumnsChanged(changedColumns, direction);
							},
							onDownload: (buildHead, buildBody, columns, data) => {
								// 转换数据以匹配表格显示
								const transformedData = data.map(row => {
									return {
										...row,
										data: row.data.map((cell, index) => {
											const columnName = columns[index]?.name;
											// 转换 current_quantity
											if (columnName === 'current_quantity') {
												switch (cell) {
													case '1888888':
														return 'High';
													case '1555555':
														return 'Medium';
													case '1111111':
														return 'Low';
													case '-111111':
														return '';
													default:
														return cell;
												}
											}
											// 转换 delist
											if (columnName === 'delist') {
												return cell === '-111111' ? 'Delist' : cell === 'new' ? 'New' : '';
											}
											// 转换 expiry_date
											if (columnName === 'expiry_date') {
												return moment(cell, 'YYYY-MM-DD').format('YYYY') === '1970' ? '' : moment(cell, 'YYYY-MM-DD').format('DD/MM/YYYY');
											}
											// 转换 active_status
											if (columnName === 'active_status') {
												return cell === '1' ? 'Active' : 'Cancelled';
											}
											return cell;
										})
									};
								});
								return `${buildHead(columns)}${buildBody(transformedData)}`.trim();
							}
						}}
					/>
				</div>
			</Dialog>
		</div>
	);
}
